import { combineReducers } from '@reduxjs/toolkit'
import {
  addTrustDeviceReducer,
  changePasswordReducer,
  checkUserReducer,
  convenienceTestQuestionnaireAnswersReducer,
  convenienceTestQuestionnaireReducer,
  convenienceTestsConfirmReducer,
  convenienceTestsDataReducer,
  convenienceTestsDraftPdfDownloadReducer,
  convenienceTestsDraftReducer,
  deleteDeviceSigningDataReducer,
  deleteDeviceTrustedDataReducer,
  deviceSigningDataReducer,
  devicesDataReducer,
  editUserDataReducer,
  editUserInfoReducer,
  editUserPreferencesReducer,
  mailingAddressRelatedProductsDataReducer,
  otpResendReducer,
  recoverPasswordReducer,
  refreshTokenDeviceReducer,
  securityDataReducer,
  taxAddressRelatedProductsDataReducer,
  updateDeviceAliasReducer,
  userInfoDataReducer,
  userPreferencesDataReducer,
} from '../slices'

export const usersReducers = combineReducers({
  deleteDeviceSigning: deleteDeviceSigningDataReducer,
  deleteDeviceTrusted: deleteDeviceTrustedDataReducer,
  devices: devicesDataReducer,
  deviceSigning: deviceSigningDataReducer,
  mailingAddressRelatedProducts: mailingAddressRelatedProductsDataReducer,
  taxAddressRelatedProducts: taxAddressRelatedProductsDataReducer,
  user: combineReducers({
    read: combineReducers({
      info: userInfoDataReducer,
      preferences: userPreferencesDataReducer,
    }),
    write: combineReducers({
      info: editUserInfoReducer,
      infoData: editUserDataReducer,
      preferences: editUserPreferencesReducer,
    }),
  }),
  convenienceTests: convenienceTestsDataReducer,
  convenienceTestsConfirm: convenienceTestsConfirmReducer,
  convenienceTestsDraft: convenienceTestsDraftReducer,
  convenienceTestsDraftPdfDownload: convenienceTestsDraftPdfDownloadReducer,
  addTrustDevice: addTrustDeviceReducer,
  otp: combineReducers({
    resend: otpResendReducer,
  }),
  refreshToken: refreshTokenDeviceReducer,
  updateDeviceAlias: updateDeviceAliasReducer,
  convenienceTestQuestionnaire: convenienceTestQuestionnaireReducer,
  convenienceTestQuestionnaireAnswers: convenienceTestQuestionnaireAnswersReducer,
  security: combineReducers({
    changePassword: changePasswordReducer,
    checkUser: checkUserReducer,
    recoverPassword: recoverPasswordReducer,
    data: securityDataReducer,
  }),
})
